import React, { useState } from 'react';
import { Field } from 'formik';
import CommonPincode from '../CommonComponent/CommonPincode';

import get from 'lodash/get';
import UploadImgComponent from '../CommonComponent/UploadImgComponent';
import UploadView from '../CommonComponent/UploadView';
import CommonInput from '../CommonComponent/CommonInput';
import Axios from 'axios';
import { useCheckFileAndUpdateError } from './checkFileUploadCriteria';

import './LpgGasUpload.css';

function RentedUploade(props) {
  const {
    setstepsInfo,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    name,
    setFileUploadErrors,
    fileUploadErrors
  } = props;

  const fileCheck = useCheckFileAndUpdateError({
    data,
    fileUploadErrors,
    setFileUploadErrors,
    name
  });

  function onChange(imgUrl, files, e) {
    data.rented.files = files;
    data.rented.imgUrl[0] = imgUrl;

    setData('rented', {
      ...data.rented,
      imgUrl: data.rented.imgUrl,
      files: data.rented.files
    });
    fileCheck(files); // start validation from here
  }
  const { imgUrl, pincode, address, city, state } = data.rented;
  const isImageUploadedLocally = imgUrl && imgUrl[0];

  return (
    <div className="rented_container">
      <div className="all_input_container">
        {/* /////// */}
        <CommonPincode
          name="rented.pincode"
          value={pincode}
          onChange={e => {
            if (e.target.value.length <= 6) {
              handleChange(e);
              setData('rented.city', '');
              setData('rented.state', '');
            }
          }}
          error={
            get(errors, 'rented.pincode', false) &&
            get(touched, 'rented.pincode', false)
          }
          errorMsg={get(errors, 'rented.pincode', false)}
          touched={get(touched, 'rented.pincode', false)}
          onPinCodeSucessOrFailure={obj => {
            const { err, data: pincodeData } = obj;
            if (!err && pincodeData) {
              setData('rented', {
                ...data.rented,
                city: pincodeData.District,
                state: pincodeData.State
              });
            } else {
              setFieldError('rented.pincode', 'Pincode is not valid');
            }
          }}
          onBlur={e => {
            handleBlur(e);
          }}
        />

        <CommonInput
          name={'rented.address'}
          value={address}
          onChange={e => {
            handleChange(e);
          }}
          onBlur={e => {
            handleBlur(e);
          }}
          legendName="Address"
          error={
            get(errors, 'rented.address', false) &&
            get(touched, 'rented.address', false)
          }
          errorMsg={get(errors, 'rented.address', false)}
          touched={get(touched, 'rented.address', false)}
        />

        <CommonInput
          name={'rented.city'}
          value={city}
          legendName="City"
          disabled
        />
        <CommonInput
          name={'rented.state'}
          value={state}
          legendName="State"
          disabled
        />
      </div>
      <div className="mt-6 rented_upload">
        {isImageUploadedLocally && (
          <>
            <img
              className="rented_upload_img cursor-pointer"
              src={imgUrl[0]}
              onClick={e => {
                if (imgUrl[0]) {
                  window.open(imgUrl[0], '_blank');
                }
              }}
              alt=""
            />
            <div>
              <UploadImgComponent
                name="rented.files"
                onChange={(imgUrl, files, e) => {
                  if (handleChange) {
                    handleChange(e);
                  }
                  onChange(imgUrl, files, e);
                }}
              >
                <p className="underline">Re-upload</p>
                {get(touched, 'rented.files', false) &&
                  get(fileUploadErrors, 'rented.files', false) && (
                    <p className="text-red-100">
                      {fileUploadErrors['rented.files']}
                    </p>
                  )}
              </UploadImgComponent>
              <p>{data.rented.files[0] && data.rented.files[0].name}</p>
            </div>
          </>
        )}
        {!isImageUploadedLocally && (
          <>
            <UploadImgComponent
              name="rented.files"
              onChange={(imgUrl, files, e) => {
                if (handleChange) {
                  handleChange(e);
                }
                onChange(imgUrl, files, e);
              }}
            >
              <UploadView
                subtext="Upload Rental Agreement"
                error={
                  get(touched, 'rented.files', false) &&
                  get(fileUploadErrors, 'rented.files', false) && (
                    <p className="text-red-100">
                      {fileUploadErrors['rented.files']}
                    </p>
                  )
                }
              />
            </UploadImgComponent>
          </>
        )}
      </div>
    </div>
  );
}

export default RentedUploade;
